module.exports = __webpack_public_path__ + "img/logo-alptracker.26bdc9d4.png";